import api from '../../../api';
import { finish, error } from '../../../modules/countries/actions/get';

export function request(dispatch) {
    api.get('/countries').then(
        data => {
          dispatch(finish(data))
        },
        ({ errors }) => dispatch(error(errors))
    );
}
